import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import {
  FaLinkedin,
  FaGithub,
  FaInstagram,
  FaEnvelope,
  FaPhoneAlt,
  FaYoutube,
  FaStackOverflow
} from "react-icons/fa";
import {
  socialMediaLinks,
  contactInfo,
  copyrightText,
} from "../config";
import SocialIconButton from "../components/SocialIconButton";
import ScrollToTopButton from "../components/ScrollToTopButton";
import BlogPreviewList from "./BlogPreviewList";
import CookieModal from "./CookieModal"; // <- dein Modal
import { useZenTitles } from "../hooks/useZenTitles";

import { useCaseTitles } from "../hooks/useCaseTitles";

const truncateTitle = (text, maxLength = 60) => {
  if (!text) return "";
  if (text.length <= maxLength) return text;
  const truncated = text.substr(0, maxLength);
  return truncated.substr(0, truncated.lastIndexOf(" ")) + " …";
};

function Footer() {
  const [showMiniFooter, setShowMiniFooter] = useState(false);
  const footerRef = useRef(null);

  // CookieModal State & Handler
  const [showCookieModal, setShowCookieModal] = useState(false);

  // Ref für das Modal, wegen forwardRef!
  const cookieModalRef = useRef(null);

  const onShowCookieSettings = useCallback(() => setShowCookieModal(true), []);
  const onCloseCookieSettings = useCallback(() => setShowCookieModal(false), []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setShowMiniFooter(!entry.isIntersecting);
      },
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
    );
    if (footerRef.current) observer.observe(footerRef.current);
    return () => observer.disconnect();
  }, []);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Cookie Consent ggf. aus localStorage laden (optional)
  // const [cookieConsent, setCookieConsent] = useState(null);

  return (
    <>
      {/* Mini-Footer */}
      {showMiniFooter && (
        <div className="fixed bottom-0 left-0 right-0  
          bg-[#d9d4c5] border-t border-[#151515]/10
        shadow-[0_-6px_18px_rgba(15, 15,15,0.45)]
          z-30 py-4 flex flex-col items-center justify-center text-xs font-mono text-gray-800 md:flex-row md:justify-between md:px-6 md:py-2
          pb-[calc(env(safe-area-inset-bottom)+0.75rem)]"
        >
          <div className="hidden font-bold pl-5 md:block ">Denis Bitter
            <span className="text-xs font-normal"> Software Architect & Full-Stack Engineering Instructor</span> </div>
          <div className="text-center block md:hidden">
            <span className="font-mono block">Software Architect & Full-Stack Engineering Instructor</span>
          </div>
          <div className="mt-0 sm:mt-0 flex  space-x-4 hidden md:flex">
            <SocialIconButton href={socialMediaLinks.linkedin} Icon={FaLinkedin} />
            <SocialIconButton href={socialMediaLinks.youtube} Icon={FaYoutube} />
            <SocialIconButton href={socialMediaLinks.instagram} Icon={FaInstagram} />
            <SocialIconButton href={socialMediaLinks.github} Icon={FaGithub} />
            <SocialIconButton href={socialMediaLinks.stack} Icon={FaStackOverflow} />
          </div>
        </div>
      )}

      {/* Haupt-Footer */}
      <div>
        <footer
          ref={footerRef}
          className="py-10 text-gray-700 bg-[#d9d4c5] text-xs sm:text-xs font-mono shadow-inner pb-[calc(env(safe-area-inset-bottom)+1rem)]"
        >
          <div className="container mx-auto px-4 flex flex-col md:flex-row md:justify-between md:items-start md:space-x-12 text-center md:text-left">
            {/* Spalte 1 */}
            <div className="md:w-1/4">
              <div className="text-xs font-bold font-mono">Denis Bitter</div>
              <div className="text-xs mb-4">Software Architect & Full-Stack Engineering Instructor<br />
<br />
               Design + Code<br /> Entwickler + Dozent<br />
</div>
           
             
              <div className="mb-1"></div>
              <div className="text-xs text-gray-800 space-y-1">
                <p>
                  <a href={`mailto:${contactInfo.email}`} className="hover:text-black hover:underline flex items-center justify-center md:justify-start">
                    <FaEnvelope className="inline mr-2" /> {contactInfo.email}
                  </a>
                </p>
                <p>
                  <a href={`tel:${contactInfo.phone.replace(/\s/g, "")}`} className="hover:text-black hover:underline flex items-center justify-center md:justify-start">
                    <FaPhoneAlt className="inline mr-2" /> {contactInfo.phone}
                  </a>
                </p>
                <p>{contactInfo.address}</p>
              </div>
            </div>
            {/* Spalte 2 */}
            <div className="md:w-1/4 mt-8 md:mt-0">
              <h3 className="font-semibold text-gray-800 mb-4">Cockpit:</h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/contact" className="hover:text-black hover:underline">
                    Sag Hallo
                  </Link>
                </li>
                <li>
                  <button
                    type="button"
                    onClick={onShowCookieSettings}
                    className="hover:underline hover:text-black"
                  >
                    Cookie
                  </button>
                </li>
                <li>
                  <Link to="/datenschutz" className="hover:text-black hover:underline">
                    Datenschutz
                  </Link>
                </li>
                <li>
                  <Link to="/impressum" className="hover:text-black hover:underline">
                    Impressum
                  </Link>
                </li>
              </ul>
            </div>
            {/* Spalte 3 */}
                              <div className="md:w-1/4 mt-8 md:mt-0">
                              <h3 className="font-semibold text-gray-800 mb-4">ZenDev:</h3>
                  <ul className="space-y-2">
                    {useZenTitles().map((zen) => (
                      <p key={zen.slug}>
                        <Link to={`/zen/${zen.slug}`} className="hover:text-black hover:underline">
                          {truncateTitle(zen.title, 40)}
                        </Link>
                      </p>
                    ))}
                  </ul>

            </div>


    {/* Spalte 4-1 */}
            <div className="md:w-1/4 mt-8 md:mt-0">
              <h3 className="font-semibold text-gray-800 mb-4">ZenDemo:</h3>
              <ul className="space-y-2">
                  <li>
                  <Link to="/dashboard?demo=lms" className="hover:text-black hover:underline">
                    ZenLMS 
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard?demo=zeneditor" className="hover:text-black hover:underline">
                    ZenPost Editor
                  </Link>
                </li>

               <li>
                    <a
                      href="https://github.com/THEORIGINALBITTER/zenpost-studio/releases"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-black hover:underline"
                    >
                      ZenPost Studio Desktop
                    </a>
                    </li>
             
              

              <li>
                    <a
                      href="https://zenpost.denisbitter.de"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-black hover:underline"
                    >
                      ZenPost Studio Web
                    </a>
                    </li>
           
              </ul>
            </div>


                  {/* Spalte 4 – CaseStudy */}
<div className="md:w-1/4 mt-8 md:mt-0">
  <h3 className="font-semibold text-gray-800 mb-4">CaseStudy:</h3>
  <ul className="space-y-2">
    {useCaseTitles().map((c) => (
      <li key={c.slug}>
        <Link
          to={`/casestudy/${c.slug}`}
          className="hover:text-black hover:underline"
        >
          {truncateTitle(c.title, 40)}
        </Link>
      </li>
    ))}
  </ul>
</div>


        


            {/* Spalte 5 */}
            <div className="md:w-1/4 mt-8 md:mt-0">
              <h3 className="font-semibold text-gray-800 mb-4">Wissen Blog:</h3>
              <BlogPreviewList />
            </div>
          </div>

          <div className="container mx-auto px-4 mt-8 flex flex-col items-center md:flex-row md:justify-between text-gray-800 text-sm">
            <p className="text-center md:text-left font-mono text-xs text-gray-600">
              {copyrightText}
            </p>
            <ScrollToTopButton scrollToTop={scrollToTop} />
          </div>
        </footer>
      </div>



      {/* CookieModal: eingebunden mit Ref, und Close */}
      {showCookieModal && (
        <CookieModal
          ref={cookieModalRef}
          onClose={onCloseCookieSettings}
        />
      )}
    </>
  );
}

export default Footer;
